export enum MessagingChannelType {
  Email = 'email',
  Push = 'push',
  Twilio = 'twilio',
  Slack = 'slack',
  Webhook = 'webhook',
  InApp = 'in_app',
}

export interface BaseMessagingChannel {
  type: MessagingChannelType;
  selectedAt: number;
  completedAt?: number;
  isDoneWithSetup?: boolean;
}

export interface MessagingChannelSlack extends BaseMessagingChannel {
  type: MessagingChannelType.Slack;
}
export interface MessagingChannelTwilio extends BaseMessagingChannel {
  type: MessagingChannelType.Twilio;
}
export interface MessagingChannelWebhook extends BaseMessagingChannel {
  type: MessagingChannelType.Webhook;
}
export interface MessagingChannelInApp extends BaseMessagingChannel {
  type: MessagingChannelType.InApp;
}

export interface MessagingChannelEmail extends BaseMessagingChannel {
  type: MessagingChannelType.Email;
  skippedLinkTrackingForDomains: string[];
  completedUniversalLinkTrackingAt?: number;
  skippedUniversalLinkTrackingAt?: number;
}

// A push platform inside the setup guide can be completed via several sources.
//
// 1) user_action: A user action, i.e. a user manually sets it up inside the setup guide.
// 2) config_found: A user action, but outside of the setup guide, i.e. via settings.
// 3) ios_fcm_setup: When iOS is set up using FCM, that completes Android too because we use the same certificate.
export enum MessagingChannelPushCompletionReason {
  UserAction = 'user_action',
  ConfigFound = 'config_found',
  IosFcmSetup = 'ios_fcm_setup',
}

export interface MessagingChannelPushPlatform {
  skippedAt?: number;
  completedAt?: number;
  completionReason?: MessagingChannelPushCompletionReason;
}

export interface MessagingChannelPush extends BaseMessagingChannel {
  type: MessagingChannelType.Push;
  ios: MessagingChannelPushPlatform;
  android: MessagingChannelPushPlatform;
}

export type MessagingChannel =
  | MessagingChannelSlack
  | MessagingChannelTwilio
  | MessagingChannelWebhook
  | MessagingChannelEmail
  | MessagingChannelPush
  | MessagingChannelInApp;

export enum PresentationLocation {
  VWB = 'vwb',
  SetupGuide = 'setup_guide',
}
